import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

// A short message carried to the next page - navigate(to, { state: { flash } })
// - e.g. "Profile saved" after returning to the dashboard
const FlashMessage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (location.state?.flash) {
      setMessage(location.state.flash);
      // Don't show it again on refresh or back
      navigate(location.pathname + location.search, { replace: true, state: {} });
    }
  }, [location, navigate]);

  return (
    <Snackbar
      open={Boolean(message)}
      autoHideDuration={4000}
      onClose={() => setMessage(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 8 }}
    >
      <Alert severity="success" variant="filled" onClose={() => setMessage(null)}>{message}</Alert>
    </Snackbar>
  );
};

export default FlashMessage;
